module.exports = __webpack_public_path__ + "static/media/Zvook_Client_Page_(optimized)3.b102ccd9.png";